import { useEffect } from "react";
import "@/App.css";
// build: 2026-06-23T12:14Z — refresh prod bundle to ship updated image placements (commit 5431b5b+)
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Journey from "@/pages/Journey";
import Building from "@/pages/Building";
import Journal from "@/pages/Journal";
import Article from "@/pages/Article";
import Media from "@/pages/Media";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [pathname]);
    return null;
}

function App() {
    return (
        <div className="App min-h-screen bg-ivory">
            <BrowserRouter>
                <ScrollToTop />
                <a href="#main-content" className="skip-link">
                    Skip to main content
                </a>
                <Navigation />
                <div id="main-content" tabIndex={-1}>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/journey" element={<Journey />} />
                        <Route path="/building" element={<Building />} />
                        <Route path="/building/:venture" element={<Building />} />
                        <Route path="/journal" element={<Journal />} />
                        <Route path="/journal/:slug" element={<Article />} />
                        <Route path="/media" element={<Media />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/privacy" element={<Privacy />} />
                        <Route path="/terms" element={<Terms />} />
                    </Routes>
                </div>
                <Footer />
                <Toaster
                    position="bottom-right"
                    toastOptions={{
                        style: {
                            background: "#1A1A1A",
                            color: "#F8F6F0",
                            border: "1px solid rgba(197,160,89,0.4)",
                            borderRadius: 0,
                            fontFamily: "Figtree, system-ui, sans-serif",
                        },
                    }}
                />
            </BrowserRouter>
        </div>
    );
}

export default App;
